import { useContext } from 'react';

import { invariant } from '@e-socna/utils';

import { ReportContext } from '../index';

export const useReportContext = () => {
  const context = useContext(ReportContext);

  invariant(
    !!context,
    'useReportContext must be used within a ReportContextProvider',
  );

  return context;
};
